<template >
  <MyHeader></MyHeader>
  <transition name="fade" mode="out-in">
    <component :is="currentContent" @nextStep="onNextStep" @data="(data) => {childData = data}" :data="childData" ></component>
  </transition>
  <MyFooter></MyFooter>
</template>

<script>
import MainContent from "@/components/MainContent";
import MyFooter from "@/components/MyFooter";
import StepOne from "@/components/StepOne";
import StepTwo from "@/components/StepTwo";
import StepError from "@/components/StepError";
import WaitForData from "@/components/WaitForData";
import MyHeader from "@/components/MyHeader";

export default {
  name: 'App',
  components: {
    MainContent,
    StepOne,
    StepTwo,
    StepError,
    MyFooter,
    WaitForData,
    MyHeader
  },
  data(){
    return{
      currentContent: 'MainContent',
      childData: {}
    }
  },
  methods: {
    onNextStep(nextComponent){
      this.currentContent = nextComponent
    }
  }
}
</script>

<style lang="css">
  @import "./assets/css/bootstrap.css";
  @import "./assets/css/style.css";

  .fade-enter-active {
    animation: fade 0.5s ease-in-out;
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    50% {
      opacity: 50%;
    }
    to {
      opacity: 1;
    }
  }

  .fade-leave-active {
    animation: slide 1s ease-in-out;
  }

  @keyframes slide {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-2000px);
    }
  }


</style>
